import type { FC} from 'react';
import { memo } from 'react';
import StandardJackpot from '../../StandardJackpot';
import type { StandardJackpotProps } from '../../../types/jackpot.types';
import styles from './Mystery.module.css';

const MysteryJackpot: FC<StandardJackpotProps> = memo((props) => {
  const mysteryIcons = {
    panel: '/group_mystery/clover',
    grand: '/group_mystery/grand',
    major: '/group_mystery/major',
    minor: '/group_mystery/minor',
    mini: '/group_mystery/mini',
  };

  return (
    <StandardJackpot
      {...props}
      icons={mysteryIcons}
      className={styles.mysteryTheme}
    />
  );
});

export default MysteryJackpot;